import styled from 'styled-components';

export const PriceText = styled.div`
  color: var(--grey700);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
